import { render, staticRenderFns } from "./EnableInterbankAndInternetTransfer.vue?vue&type=template&id=2c19681d&"
import script from "./EnableInterbankAndInternetTransfer.vue?vue&type=script&lang=js&"
export * from "./EnableInterbankAndInternetTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports